/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from '@polleverywhere/backbone'
import _ from 'underscore'

// @namespace Model
class Collection extends Backbone.Collection {
  include (mod) {
    return _.extend(this, mod(this))
  }

  parse (models, resp) {
    /*
     * try to pull off pagination data
     * from headers if it's there
     */
    try {
      const pagingData = JSON.parse(resp.xhr.getResponseHeader('X-Pagination'))

      /*
       * if the collection has an attached filter
       * model, set the paging data on it
       */
      if (this.params != null) {
        this.params(pagingData)
      }
    } catch (error) {}

    return super.parse(...arguments)
  }

  /*
   * Pass model through to ajax prefilter so we can set basic auth
   * credentials on a per model basis
   */
  sync (method, model, options) {
    if (options == null) { options = {} }
    options.model = model
    return super.sync(method, model, options)
  }
}

export default Collection
